<div class="modal-content end-coverage-summary-modal" cdkTrapFocus [cdkTrapFocusAutoCapture]="false">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">
      {{ "End_Coverage_Title" | globalTranslate }}
    </h1>
  </div>
  <div class="modal-body">
    @if(rmcVolTermChangeSwitch){
      <p>{{ "VOLTERM_END_COVERAGE_TEXT1" | globalTranslate }}</p>
    } @else {
      <p>{{ "End_Coverage_Text1" | globalTranslate }}</p>
    }


    @for (entityDetail of filteredEntityDetails; track entityDetail) {
    <div>
      <p>
        <strong>{{ entityDetail.firstNam }} {{ entityDetail.lastNam }}</strong>
      </p>
    </div>
    }
    @if(rmcVolTermChangeSwitch){
      <p [innerHTML]="'VOLTERM_END_COVERAGE_TEXT2' | globalTranslate"></p>
    } @else {
      <p>
        {{ "End_Coverage_Text2" | globalTranslate }}
        <strong>{{ "End Coverage" | globalTranslate }}.</strong>
      </p>
    }

    @if(rmcVolTermChangeSwitch){
    <p>{{ "VOL_TERM_END_COVERAGE_STATIC_TEXT" | globalTranslate }}</p>
    }@else {
    <p>{{ "END_COVERAGE_STATIC_TEXT2" | globalTranslate }}</p>
    }
  </div>

  <!-- <div class="modal-footer d-block">
  <div class="row g-3 justify-content-end">
    <div class="col-md-4 order-md-1">
      <button type="button" class="btn d-grid btn-link" (click)="onConfirm()">END COVERAGE</button>
    </div>
    <div class="col-md-3 order-md-2">
      <button type="button" class="btn d-grid btn-secondary" (click)="onCancel()">Cancel</button>
    </div>
  </div>
</div> -->
  <div class="modal-footer justify-content-start">
    <div class="me-2 ml-2">
      <button type="button" id="dialog" class="btn btn-link" (click)="onConfirm()">
        {{ "End Coverage" | globalTranslate }}
      </button>
    </div>
    <div class="me-2 ml-2">
      <button type="button" id="dialog" class="btn btn-secondary" (click)="onCancel()">
        {{ "CANCEL" | globalTranslate }}
      </button>
    </div>
  </div>
</div>